// Support log links (CR_20260913 S3): the record an audited change belongs to, and the page that opens it.
// A child row's parent (support_audit.ref_table/ref_id, from app.support_audit_refs()) wins over its own row_id.

export interface AuditRef {
  table_name: string;
  row_id: string | null;
  ref_table: string | null;
  ref_id: string | null;
}

export interface RecordTarget {
  table: string;
  id: string;
}

// records with their own page
const DETAIL: Record<string, string> = {
  assets: '/assets/',
  transfers: '/transfers/',
  asset_requests: '/requests/',
  stock_counts: '/counts/',
  sites: '/sites/',
  projects: '/projects/',
};

// records managed on a list page (memberships: rows logged before ref_table/ref_id existed)
const LIST: Record<string, string> = {
  profiles: '/settings/users',
  memberships: '/settings/users',
  site_memberships: '/settings/users',
  project_memberships: '/settings/users',
  asset_categories: '/settings/categories',
  rate_cards: '/settings/rates',
  alert_rules: '/settings/notifications',
  alerts: '/alerts',
};

export function recordTarget(c: AuditRef): RecordTarget | null {
  if (c.ref_table && c.ref_id) return { table: c.ref_table, id: c.ref_id };
  return c.row_id ? { table: c.table_name, id: c.row_id } : null;
}

export function recordPath(target: RecordTarget): string | null {
  const detail = DETAIL[target.table];
  if (detail) return detail + encodeURIComponent(target.id);
  return LIST[target.table] ?? null;
}
